import { Reducer } from 'redux';
import { PURGE } from 'redux-persist';
import { RateData, RatingState, RatingTypes } from './types';

const INITIAL_STATE: RatingState = {
    data: {} as RateData,
    loading: false,
    submittedRating: false,
    errorOnSubmit: false,
    error: undefined,
};

const reducer: Reducer<RatingState> = (state: RatingState = INITIAL_STATE, action) => {
    switch (action.type) {
        case PURGE:
            return { ...INITIAL_STATE };
        case RatingTypes.SET_COURSE_RATE_REQUEST:
        case RatingTypes.SET_CONTENT_RATE_REQUEST:
        case RatingTypes.SET_PROGRAM_RATE_REQUEST:
            return { ...INITIAL_STATE, loading: true };
        case RatingTypes.SET_COURSE_RATE_SUCCESS:
        case RatingTypes.SET_CONTENT_RATE_SUCCESS:
        case RatingTypes.SET_PROGRAM_RATE_SUCCESS:
            return { ...state, loading: false, data: { ...action.payload }, submittedRating: true };
        case RatingTypes.SET_CONTENT_RATE_FAILURE:
        case RatingTypes.SET_PROGRAM_RATE_FAILURE:
            return { ...state, loading: false, data: { ...action.payload }, errorOnSubmit: true, submittedRating: false };
        case RatingTypes.CLEAR_RATE:
            return { ...INITIAL_STATE };
        case RatingTypes.GET_RATE_REQUEST:
            return { ...INITIAL_STATE, loading: true };
        case RatingTypes.GET_RATE_SUCCESS:
            return { ...state, loading: false, data: { ...action.payload }, submittedRating: false };
        case RatingTypes.GET_RATE_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default reducer;
